import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface MessageAssistant { role: 'utilisateur' | 'assistant'; texte: string; }
export interface ReponseAssistant { reponse: string; suggestions: string[]; questionsRestantes: number; }

/** Assistant IA de la ferme (administrateur et comptable ; quota quotidien) */
@Injectable({ providedIn: 'root' })
export class AssistantService {

  private readonly base = `${environment.BASE_URL}/api/assistant`;

  constructor(private http: HttpClient) {}

  statut(): Observable<{ actif: boolean; questionsRestantes: number }> { return this.http.get<any>(`${this.base}/statut`); }

  question(question: string, historique: MessageAssistant[]): Observable<ReponseAssistant> {
    return this.http.post<ReponseAssistant>(`${this.base}/questions`, { question, historique });
  }
}
